export const SAVE_LOCALUSER = 'save/localuser'; // 修改登录信息
export const GET_LOCALUSER = 'get/localuser'; // 获取登录信息
export const SAVE_HOMEDATA = 'save/homedata'; // 修改登录信息
export const GET_HOMEDATA = 'get/homedata'; // 获取登录信息
export const SAVE_LOCALCART = 'save/localcart'; // 修改登录信息
export const INIT_LOCALCART = 'init/localcart'; // 修改登录信息
export const GET_LOCALCART = 'get/localcart'; // 获取登录信息



// WEBPACK FOOTER //
// ./src/store/types.js